import React from 'react'
import * as S from './styled'

interface Props {
    children: React.ReactNode
}
const TemplateContainer: React.FC<Props> = ({ children }) => (
    <S.TemplateContainer style={{height:'calc(calc(var(--vh, 1vh) * 100) - 72px)'}}>
        <div>{children}</div>
    </S.TemplateContainer>
)

export default TemplateContainer
